import { render, staticRenderFns } from "./ConsumptionsSubPacksTable.vue?vue&type=template&id=50190674&"
import script from "./ConsumptionsSubPacksTable.vue?vue&type=script&lang=ts&"
export * from "./ConsumptionsSubPacksTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports